// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__icon___-HLTi","icon-exposed-folder":"icon__icon-exposed-folder___1Gl_2","exposed":"icon__exposed___14Jj7","icon--huge":"icon__icon--huge___8BJO4","icon--small":"icon__icon--small___6mxIJ","icon--text":"icon__icon--text___bIKA1","icon--tiny":"icon__icon--tiny___1VJA1"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Icon/icon.scss
// module id = 124
// module chunks = 0